import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { getPartnerEmail } from "../../../../reducers/userInfo"
import { updatePartnerEmail } from "../../../../actions/userActions"
import { FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { Spacer } from "../../atoms/Atoms"
import { FleLinkWrapper } from "../../atoms/Links"
import React from "react"
import L10n from "../../../../lib/carrot-l10n"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { Form } from "components/views/atoms/forms/Form"
import { regexes } from "utils/Regexes"
import { TopSection } from "../TopSection"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AboutYourPartnerEmail = ({ next, history }) => {
  const { register, handleSubmit, errors } = useForm()
  const partnerEmail = useSelector(getPartnerEmail)
  const dispatch = useDispatch()

  const submitPartnerEmail = async (data) => {
    await dispatch(updatePartnerEmail(data), null)
    history.push(next)
  }

  return (
    <FleLayout>
      <Form onSubmit={handleSubmit(submitPartnerEmail)}>
        <TopSection progressStep={3} leftOrBackArrow={<BackArrow />} />
        <SwitchH2ToBodyLarge>{l`What's your partner's email address?`}</SwitchH2ToBodyLarge>
        <Spacer height={3} />
        <CompleteFormInput
          name={"partnerEmail"}
          label={"Partner's email address"}
          defaultValue={partnerEmail}
          errors={errors}
          ref={register({
            pattern: {
              value: regexes.email,
              message: l`client.invalidEmail`
            }
          })}
        />
      </Form>
      <FleLinkWrapper>
        <ContinueArrow onClick={handleSubmit(submitPartnerEmail)} />
      </FleLinkWrapper>
    </FleLayout>
  )
}

export { AboutYourPartnerEmail }
